import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { PricedEntity, formatCurrency, getSavingsAmount, getEffectivePrice, getMrp, hasDiscount } from '../../utils/pricing';

interface PriceDisplayProps {
  item: PricedEntity;
  priceVariant?: 'body2' | 'body1' | 'h6' | 'h5' | 'h4';
  mrpVariant?: 'caption' | 'body2' | 'body1';
  showSalePrice?: boolean;
  showDiscountChip?: boolean;
  discountChipSize?: 'small' | 'medium';
  sx?: SxProps<Theme>;
}

const PriceDisplay: React.FC<PriceDisplayProps> = ({
  item,
  priceVariant = 'h6',
  mrpVariant = 'body2',
  showSalePrice = true,
  showDiscountChip = true,
  discountChipSize = 'small',
  sx
}) => {
  const salePrice = getEffectivePrice(item);
  const mrp = getMrp(item);
  const discounted = hasDiscount(item);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', ...sx }}>
      {showSalePrice && (
        <Typography variant={priceVariant} color="primary">
          {formatCurrency(salePrice)}
        </Typography>
      )}
      {discounted && (
        <>
          <Typography variant={mrpVariant} color="text.secondary" sx={{ textDecoration: 'line-through' }}>
            {formatCurrency(mrp)}
          </Typography>
          {showDiscountChip && (
            <Chip
              size={discountChipSize}
              label={`Save ${formatCurrency(getSavingsAmount(item))}`}
              sx={{
                bgcolor: '#E53935',
                color: '#fff',
                fontWeight: 600,
                ...(discountChipSize === 'small' ? { height: 20 } : {})
              }}
            />
          )}
        </>
      )}
    </Box>
  );
};

export default PriceDisplay;
